<template>
  <div>

    <Collapsable
      :collapsed="collapsed"
      :title="$t('kiosks.sessions.header')"
    >

      <span slot="beforeCollapse" class="d-flex align-items-center">

        <div class="d-flex align-items-center" v-if="screeningsInView.length">
          <span class="mr-3 no-print"><b>{{ $t('agenda.screenings.show_map') }}</b></span>
          <slider class="no-print" v-model="viewByMap"></slider>
        </div>

        <Searchable
          class="mr-1"
          :querySearch.sync="querySearch" />

      </span>

      <div class="row">

        <TableView
          ref="sessionsTable"
          :class="{ 'col-8': viewByMap, 'col-12': !viewByMap }"
          :kiosk="kiosk"
          @loaded="onTableViewLoaded" />

        <ScreeningsMap
          class="col-4"
          v-if="viewByMap"
          :data="screeningsInView"
          :isActive="false" />

      </div>
    </Collapsable>

  </div>
</template>

<script>
import Collapsable from '@/components/common/Collapsable'
import Searchable from '@/components/common/Searchable'
import TableView from './TableView'
import ScreeningsMap from '@/components/agenda/screenings/ScreeningsMap'
import Slider from '@/components/common/Slider'

export default {
  props: {
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    },
    kiosk: {
      type: Object,
      required: false
    }
  },
  components: {
    Collapsable,
    Slider,
    TableView,
    Searchable,
    ScreeningsMap
  },
  data: function () {
    return {
      viewByMap: false,
      screeningsInView: [],
      querySearch: ''
    }
  },
  methods: {
    onTableViewLoaded: function ({ data }) {
      if (data !== undefined && data !== null) {
        this.screeningsInView = data
      }
    }
  },
  watch: {
    querySearch: function (search) {
      this.$refs.sessionsTable.$refs.kioskSessionsTable.setFilter(search)
    }
  }
}
</script>
